export const isAcceptingOffers = value => value === true || value === 'yes';